// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"611befa3","971":"757d7152"}[chunkId] + ".chunk.js";
};